export const openMobileApp = (pathname = "app") => {
  const userAgent = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);

  const cleanPathname = pathname.replace(/^\/+/, "");

  if (isIOS) {
    window.location.href = `cur8://${cleanPathname}`;
  }

  if (isAndroid) {
    const host = window.location.hostname.includes("cur8.capital")
      ? "invest.cur8.capital"
      : "invest.pub.islamicfinanceguru.dev";
    window.location.href = `https://${host}/${cleanPathname}`;
  }
};
